<!-- Chat new component if base model chat feature is DISABLED for this organization -->
<div *ngIf="!this.organization.currentOrganization$.value?.settings?.features?.includes('BaseModelChat')"
    class="h-full flex justify-center overflow-x-hidden border-app-chat-sources-border-color">
    <!-- Collection selection -->
    <div class="max-w-[814px] px-8 flex flex-col items-center gap-5 mt-[20vh] " *ngIf="!collectionControl.value">
        <h1 class="font-semibold text-[34px] text-center" i18n>Collectie selecteren</h1>
        <p *ngIf="connection.role.value !== 'chatter'" class="text-xl" i18n>
            Selecteer een collectie, zodat de chatbot weet met welke informatie je het meest geholpen wordt.
            Je kunt <a routerLink="/collections/new" class="text-app-global-secondary font-semibold">hier</a> een
            nieuwe collectie aanmaken.
        </p>
        <p *ngIf="connection.role.value === 'chatter'" class="text-base leading-[1.4]" i18n>
            Selecteer een collectie, zodat de chatbot weet met welke informatie je het meest geholpen wordt.
        </p>
        <smart-select class="w-full" [settings]="selectCollection">
            <ng-template #matOptionContent let-item>
                <div class="flex items-center justify-between w-full">
                    <p [ngClass]="{'text-app-global-text-secondary': item.status === 'processing'}"
                        class="text-ellipsis overflow-hidden line-clamp-1">{{item.name}}</p>
                    <mat-icon svgIcon="file-clock" class="w-5 h-5 shrink-0 text-gray-500 translate-x-[16px]"
                        *ngIf="item.status === 'processing'"></mat-icon>
                </div>
            </ng-template>
        </smart-select>
    </div>
</div>
<!-- Chat new component if base model chat feature is ENABLED for this organization -->
<div *ngIf="this.organization.currentOrganization$.value?.settings?.features?.includes('BaseModelChat')"
    class="flex flex-col xl:flex-row items-center justify-center lg:mt-[25vh] gap-[30px] m-5">
    <!-- Chat with collection -->
    <div class="md:w-[470px] md:h-[315px] p-[30px] flex flex-col items-center gap-[20px] border rounded-[20px]">
        <div class="flex flex-col gap-[10px]">
            <h1 class="text-[34px] leading-[1.2] text-center" i18n>Chatten <span class="font-semibold">met
                    collectie</span></h1>
            <p *ngIf="connection.role.value !== 'chatter'" class="text-base leading-[1.4]" i18n>
                Selecteer een collectie, zodat de chatbot weet met welke informatie je het meest geholpen wordt.
                Je kunt <a routerLink="/collections/new" class="text-app-global-secondary font-semibold">hier</a>
                een nieuwe collectie aanmaken.
            </p>
            <p *ngIf="connection.role.value === 'chatter'" class="text-base leading-[1.4]" i18n>
                Selecteer een collectie, zodat de chatbot weet met welke informatie je het meest geholpen wordt.
            </p>
        </div>
        <!-- Select collection -->
        <smart-select class="w-full" [settings]="selectCollection">
            <ng-template #matOptionContent let-item>
                <div class="flex items-center justify-between w-full">
                    <p [ngClass]="{'text-app-global-text-secondary': item.status === 'processing', 'text-app-global-tertiary': collectionControl.value?.id === item.id}"
                        class="text-ellipsis overflow-hidden line-clamp-1">{{item.name}}</p>
                    <mat-icon svgIcon="file-clock" class="w-5 h-5 shrink-0 text-gray-500 translate-x-[16px]"
                        *ngIf="item.status === 'processing'"></mat-icon>
                </div>
            </ng-template>
        </smart-select>
        <button mat-flat-button color="secondary" (click)="navigateToCollectionChat()"
            class="w-full flex items-center justify-center mt-auto !min-h-[45px] !rounded-full" i18n>
            Chatten met collectie
        </button>
    </div>
    <!-- Chat without collection (base model) -->
    <div *ngIf="organization.currentOrganization$.value?.settings?.features?.includes('BaseModelChat')"
        class="md:w-[470px] md:h-[315px] p-[30px] flex flex-col items-center gap-[20px] border rounded-[20px]">
        <div class="flex flex-col gap-[10px]">
            <h1 class="text-[34px] leading-[1.2] text-center" i18n>Chatten <span class="font-semibold">zonder
                    collectie</span></h1>
            <p class="text-base leading-[1.4]" i18n>
                Je kunt ook een chat starten zonder gebruik te maken van een collectie. In deze chat is het mogelijk om
                tijdens het gesprek bestanden te uploaden en hierover in gesprek te gaan, bijvoorbeeld om notulen van
                een vergadering uit te werken.
            </p>
        </div>
        <button mat-flat-button color="primary" routerLink="/chat"
            class="w-full flex items-center justify-center !min-h-[45px] !rounded-full mt-auto" i18n>
            Chatten zonder collectie
        </button>
    </div>
</div>